// Shared accessibility messages for Swiper instances (UI texts kept in German)
export const a11y = {
    enabled: true,
    prevSlideMessage: 'Vorheriger slide',
    nextSlideMessage: 'Nächster slide',
    firstSlideMessage: 'Das ist der erste slide',
    lastSlideMessage: 'Das ist der letzte slide'
};
